//styles
import styled from 'styled-components/macro';

//assets
import CheckmarkWhiteSvg from 'assets/icons/office/checkmarkWhiteSvg.svg';

export const CheckboxContainer = styled.div<{ margin?: string; display?: string; gap?: string }>`
  position: relative;

  display: ${({ display }) => (display ? display : 'grid')};
  flex-direction: row;
  flex-wrap: wrap;

  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${({ gap }) => (gap ? gap : '1rem')};

  width: 100%;

  margin: ${({ margin }) => margin || '0 1rem 0 0'};
`;

export const CheckboxWrapper = styled.label<{ marginRight?: string; bgColorChecked?: string }>`
  position: relative;

  display: flex;
  align-items: center;
  margin-right: ${({ marginRight, theme }) => (marginRight ? marginRight : theme.spacing.one)};
  padding: 0 0 0 1.25rem;

  color: ${({ theme }) => theme.colors.black_100};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
  text-align: left;

  cursor: pointer;
  span:after {
    display: none;

    width: 100%;
    height: 100%;

    background-image: url(${CheckmarkWhiteSvg});
    background-repeat: no-repeat;
    background-position: center;
  }

  input:checked ~ span {
    border: none;

    background-color: ${({ theme, bgColorChecked }) =>
      bgColorChecked ? bgColorChecked : theme.colors.primary_80};
  }

  input:checked ~ span:after {
    display: block;
  }
`;

export const Input = styled.input`
  position: absolute;
  cursor: pointer;

  opacity: 0;
  left: 0;
  z-index: 1;
`;

export const CheckBox = styled.span<{ width?: string; height?: string; bgColor?: string }>`
  position: absolute;
  left: 0;

  width: ${({ width }) => (width ? width : '1rem')};
  height: ${({ height }) => (height ? height : '1rem')};

  border: 1px solid ${({ theme }) => theme.colors.black_40};
  border-radius: 4px;

  background-color: ${({ theme, bgColor }) => (bgColor ? bgColor : theme.colors.white)};
  &:after {
    position: absolute;

    display: block;

    content: '';
  }
`;
